import React, { useState } from 'react';
import { Menu, MenuButton, MenuList, MenuItem, IconButton, Tooltip } from '@chakra-ui/react';
import { faEllipsisH, faCloudArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { MultiFileUploadModal, DocumentConfig } from './MultiFileUploadModal';
import { Icon } from 'shared-components';
import type { MultiFileUploadV2FileItem as FileItem } from 'shared-components';

interface UploadIconBtnProps {
  onProceed: (files: FileItem[], deletedS3Keys?: string[]) => void;
  onDeleteExistingFile?: (s3Key: string) => Promise<void>;
  uploadedSuccessfully: boolean;
  fileUploadError: string | null;
  deletedSuccessfully: boolean;
  documentConfig: DocumentConfig;
  hide?: boolean;
  existingFiles?: {
    urls?: string[];
    sKeys?: string[];
    s3Keys?: string[];
  };
}
const UploadIconBtn: React.FC<UploadIconBtnProps> = ({
  onProceed,
  onDeleteExistingFile,
  hide = false,
  documentConfig,
  uploadedSuccessfully,
  fileUploadError,
  deletedSuccessfully,
  existingFiles,
}) => {
  const [isFileUploadModal, setIsFileUploadModal] = useState(false);

  if (hide) return null;

  return (
    <>
      {/* Upload Modal */}
      <MultiFileUploadModal
        id="upload-modal"
        isOpen={isFileUploadModal}
        onClose={() => setIsFileUploadModal(false)}
        onProceed={onProceed}
        onDeleteExistingFile={onDeleteExistingFile}
        uploadedSuccessfully={uploadedSuccessfully}
        fileUploadError={fileUploadError}
        deletedSuccessfully={deletedSuccessfully}
        documentConfig={{
          ...documentConfig,
          acceptedFileTypes: ['.pdf', '.jpg', '.jpeg', '.png'],
          maxFileSize: 10 * 1024 * 1024,
        }}
        existingFiles={existingFiles}
      />

      {/* Icon Button */}
      <Menu placement="bottom-end">
        <Tooltip hasArrow placement="top" label="More actions">
          <MenuButton
            as={IconButton}
            icon={<Icon icon={faEllipsisH} color={'inherit'} />}
            size="sm"
            variant="secondary"
            aria-label="More actions"
          />
        </Tooltip>

        <MenuList>
          <MenuItem onClick={() => setIsFileUploadModal(true)} icon={<Icon icon={faCloudArrowUp} fixedWidth />}>
            Upload file
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default UploadIconBtn;
